import { render, staticRenderFns } from "./OffenePosten.vue?vue&type=template&id=6647f037&"
import script from "./OffenePosten.vue?vue&type=script&lang=js&"
export * from "./OffenePosten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports